import { render, staticRenderFns } from "./organization-transaction-card.vue?vue&type=template&id=5af9e205"
import script from "./organization-transaction-card.vue?vue&type=script&lang=js"
export * from "./organization-transaction-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports